<template>
  <v-app>
    <v-container
      fluid
      class="fill-height"
    >
      <v-row>
        <v-col class="text-center">
          <v-progress-circular
            color="primary"
            indeterminate
            size="70"
          />
          <p class="text-caption pt-3">
            Authenticating...
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
    name: "AppLogin",
    mounted() {
        this.initSession();
    },
    methods: {
        initSession() {
            var token = localStorage.getItem("admin_user_token");
            if (!token) {
                console.log("No token found, redirecting...");
                window.location.href = this.AUTH_APP_URL + "/?client_id=" + this.AUTH_CLIENT_ID;
            } else {
                console.log("Token found, proceed...");
                this.$router.push("/home");
            }
        }
    }
};
</script>